(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-daddy-paw"]) return;
  try {
    
document.querySelector('.mobile-menu-toggle').onclick = () => {
  document.querySelector('.hero-nav').classList.toggle('active');
};

document.addEventListener('click', function(e){
  const nav = document.querySelector('.hero-nav');
  const toggle = document.querySelector('.mobile-menu-toggle');

  if(nav.classList.contains('active') && !nav.contains(e.target) && !toggle.contains(e.target)){
    nav.classList.remove('active');
  }
});

document.querySelectorAll('.hero-nav-item.has-sub > a').forEach(link=>{
  link.addEventListener('click', e=>{
    if (window.innerWidth < 768){
      e.preventDefault();
      link.parentElement.classList.toggle('open');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
